// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-data-progress {
  width: 0;
  height: 100%;
  padding: 0.125rem;
  background: #f4ede6;
  border-radius: 0 0.0625rem 0.0625rem 0;
  position: relative;
}
.container-data-progress .anticon-double-left,
.container-data-progress .anticon-double-right {
  font-size: 0.1rem;
  position: absolute;
  color: #b4ada9;
  right: 0.0125rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;
}
.container-data-progress .anticon-double-left:hover,
.container-data-progress .anticon-double-right:hover {
  font-size: 0.125rem;
}
.container-data-progress .container-data-progress-main {
  width: 100%;
  height: 100%;
  display: none;
}
.container-data-progress .progress {
  margin-bottom: 0.125rem;
}
.container-data-progress .progress-file-tree .tree-title-name {
  display: inline-flex;
  width: 50%;
}
.container-data-progress .progress-file-tree .tree-title-name .title-text {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.container-data-progress-tree {
  background: #fff;
  border-radius: 0.0625rem;
  padding: 0.0625rem;
  height: calc(100% - 1.75rem);
  overflow: hidden;
}
.container-data-progress-tree h4 {
  font-size: 0.1rem;
  font-weight: bold;
  margin-bottom: 0.0625rem;
}

.container-data-progress-show {
  width: 20%;
}
.container-data-progress-show .container-data-progress-main {
  display: block;
}

.progress-loading .progress-file-tree .tree-title-name {
  display: inline-flex;
  width: 80%;
}
.progress-loading .progress-file-tree .tree-title-name .title-text {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/component/containerProgress/index.scss"],"names":[],"mappings":"AAAA;EACE,QAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,sCAAA;EACA,kBAAA;AACF;AAAE;;EAEE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;AAEJ;AADI;;EACE,mBAAA;AAIN;AADE;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAGJ;AADE;EACE,uBAAA;AAGJ;AAAI;EACE,oBAAA;EACA,UAAA;AAEN;AADM;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAGR;AACE;EACE,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AACJ;AAAI;EACE,iBAAA;EACA,iBAAA;EACA,wBAAA;AAEN;;AAEA;EACE,UAAA;AACF;AAAE;EACE,cAAA;AAEJ;;AAGI;EACE,oBAAA;EACA,UAAA;AAAN;AACM;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACR","sourcesContent":[".container-data-progress {\n  width: 0;\n  height: 100%;\n  padding: 20px;\n  background: #f4ede6;\n  border-radius: 0 10px 10px 0;\n  position: relative;\n  .anticon-double-left,\n  .anticon-double-right {\n    font-size: 16px;\n    position: absolute;\n    color: #b4ada9;\n    right: 2px;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 2;\n    cursor: pointer;\n    &:hover {\n      font-size: 20px;\n    }\n  }\n  .container-data-progress-main {\n    width: 100%;\n    height: 100%;\n    display: none;\n  }\n  .progress {\n    margin-bottom: 20px;\n  }\n  .progress-file-tree {\n    .tree-title-name {\n      display: inline-flex;\n      width: 50%;\n      .title-text {\n        display: block;\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n  &-tree {\n    background: #fff;\n    border-radius: 10px;\n    padding: 10px;\n    height: calc(100% - 280px);\n    overflow: hidden;\n    h4 {\n      font-size: 16px;\n      font-weight: bold;\n      margin-bottom: 10px;\n    }\n  }\n}\n.container-data-progress-show {\n  width: 20%;\n  .container-data-progress-main {\n    display: block;\n  }\n}\n.progress-loading {\n  .progress-file-tree {\n    .tree-title-name {\n      display: inline-flex;\n      width: 80%;\n      .title-text {\n        display: block;\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
